// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* OnboardingPage.css */
.onboarding-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 50vh;
    padding: 20px;
    max-width: 600px;
    margin:  100px auto;
    background: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.progress-indicator {
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-bottom: 20px;
}

.step {
    padding: 10px;
    border-radius: 5px;
    background: #dcca98; /* Primary color */
    color: #144040; /* Secondary color */
    font-weight: bold;
}

.step.active {
    background: #144040; /* Secondary color for active state */
    color: #fff;
}

.onboarding-content {
    width: 100%;
    text-align: center;
}

.onboarding-step {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.input-field {
    width: 80%;
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border: 1px solid #ccc;
}

.primary-button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    background-color: #144040; /* Secondary color */
    color: #fff;
    font-size: 1em;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.primary-button:hover {
    background-color: #0f2d2d; /* Slightly darker shade for hover */
}

.secondary-button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    background-color: #dcca98; /* Primary color */
    color: #144040; /* Secondary color text */
    font-size: 1em;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-right: 10px;
}

.secondary-button:hover {
    background-color: #b89e74; /* Slightly darker shade for hover */
}

.navigation-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/AutoGrader/OnboardingPage.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB,EAAE,kBAAkB;IACvC,cAAc,EAAE,oBAAoB;IACpC,iBAAiB;AACrB;;AAEA;IACI,mBAAmB,EAAE,qCAAqC;IAC1D,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB,EAAE,oBAAoB;IAC/C,WAAW;IACX,cAAc;IACd,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB,EAAE,oCAAoC;AACnE;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB,EAAE,kBAAkB;IAC7C,cAAc,EAAE,yBAAyB;IACzC,cAAc;IACd,eAAe;IACf,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB,EAAE,oCAAoC;AACnE;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB","sourcesContent":["/* OnboardingPage.css */\n.onboarding-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 50vh;\n    padding: 20px;\n    max-width: 600px;\n    margin:  100px auto;\n    background: #f9f9f9;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.progress-indicator {\n    display: flex;\n    justify-content: space-around;\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.step {\n    padding: 10px;\n    border-radius: 5px;\n    background: #dcca98; /* Primary color */\n    color: #144040; /* Secondary color */\n    font-weight: bold;\n}\n\n.step.active {\n    background: #144040; /* Secondary color for active state */\n    color: #fff;\n}\n\n.onboarding-content {\n    width: 100%;\n    text-align: center;\n}\n\n.onboarding-step {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.input-field {\n    width: 80%;\n    padding: 10px;\n    margin: 10px 0;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n}\n\n.primary-button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    background-color: #144040; /* Secondary color */\n    color: #fff;\n    font-size: 1em;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.primary-button:hover {\n    background-color: #0f2d2d; /* Slightly darker shade for hover */\n}\n\n.secondary-button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    background-color: #dcca98; /* Primary color */\n    color: #144040; /* Secondary color text */\n    font-size: 1em;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin-right: 10px;\n}\n\n.secondary-button:hover {\n    background-color: #b89e74; /* Slightly darker shade for hover */\n}\n\n.navigation-buttons {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
